    angular.module('egg.order')
        .factory('EggComment', function ($resource) {
            return $resource('/crm/api/egg-stockline-information/:client/:product/:unit', {}, {});
        })
        .directive('eggStocklineInformationDirective', function ($filter, $document, $compile, $parse, EggComment, toastr) {
            return {
                restrict: 'AE',
                scope: {
                    dueDate: '=',
                    client: '=',
                    product: '=',
                    unit: '='
                },
                templateUrl: "app/egg/order/egg-stockline-information-directive/egg-stockline-information-directive.tpl.html",
                link: function (scope, $element, $attrs) {

                    onInit();

                    var params = {
                        dueDate: scope.dueDate,
                        client: scope.client.id,
                        product: scope.product.id,
                        unit: scope.unit.id
                    };

                    EggComment.get(params, function (eggComment) {
                        scope.eggStockLineInformation = eggComment;
                    });

                    scope.save = function () {
                        scope.isSaving = true;
                        EggComment.save(params, scope.eggStockLineInformation).$promise
                            .then(function (result) {
                                scope.eggStockLineInformation = result;
                                toastr.success("Zapisano");
                            })
                            .finally(function () {
                                scope.isSaving = false;
                            });
                    };

                    // scope.delete = function () {
                    //     scope.isSaving = true;
                    //     EggComment.delete(params).$promise.then(function () {
                    //         onInit();
                    //         scope.isSaving = false;
                    //         toastr.success("Usunięto");
                    //     });
                    // };

                    scope.clearBestBeforeDate = function () {
                        scope.eggStockLineInformation.bestBeforeDate = null;
                    };

                    function onInit() {
                        scope.eggStockLineInformation = {
                            comment: "",
                            bestBeforeDate: null
                        };
                    }
                }
            };
        });
